import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// Slices
import authReducer from "./features/AuthSlice";
import billingReducer from "./features/BillingDeterminantSlice";
import customerReducer from "./features/CustomerSlice";
import meterReducer from "./features/MeterSlice";
import veeReducer from "./features/VeeSlice";
import readClusterReducer from "./features/ReadClusterSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  billing: billingReducer,
  customer: customerReducer,
  meter: meterReducer,
  vee: veeReducer,
  readCluster: readClusterReducer,
});

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["customer", "meter", "readCluster"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV === "development",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

const persistor = persistStore(store);

// Export types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export { store, persistor };
